import logoMetra from '@/assets/metro-warszawa.svg';
import type { LiniaMetra } from '@/lib/liniaMetra';

/**
 * Oficjalny znak Metra Warszawskiego (żółte koło, czerwone „M”) — ten sam, który człowiek widzi
 * przy wejściu na stację. Do 29.09 był tu czerwony kwadracik z białym „M”: podobny, ale nie ten
 * znak. Licencja pliku: w komentarzu w `src/assets/metro-warszawa.svg` (PD-textlogo).
 * Jedno miejsce dla całej aplikacji: wyniki, oferta, mapa, pole obszaru.
 */
export function WarsawMetroIcon({ size = 14 }: { size?: number }) {
  return (
    <img
      src={logoMetra}
      alt=""
      aria-hidden
      width={size}
      height={size}
      className="inline-block shrink-0"
      style={{ width: size, height: size }}
    />
  );
}

/**
 * Chip linii metra w kolorze z oficjalnego schematu: M1 niebieska, M2 czerwona, M3 zielona,
 * M4 pomarańczowa. Kolor z tokenów (`bg-metro-m1`…), nigdy z hexa w komponencie.
 */
const KLASA_LINII: Record<LiniaMetra, string> = {
  M1: 'bg-metro-m1',
  M2: 'bg-metro-m2',
  M3: 'bg-metro-m3',
  M4: 'bg-metro-m4',
};

export function ChipLiniiMetra({ linia, className = '' }: { linia: LiniaMetra; className?: string }) {
  return (
    <span
      className={`inline-flex h-4 min-w-[1.75rem] shrink-0 items-center justify-center rounded px-1 text-[10px] font-bold leading-none text-white ${KLASA_LINII[linia]} ${className}`}
    >
      {linia}
    </span>
  );
}
